import { Injectable } from '@angular/core';
import { NotificationCenterComponent } from '@components/navbar/notification-center/notification-center.component';
import { environment } from '@environments/environment';
import { CurrentUser } from '@models/Core/CurrentUser';
import _ from 'lodash';
import * as io from 'socket.io-client';

@Injectable()
export class UserSocketService {
  private socket: io.Socket;
  private listeners: any[];

  connect(token: string) {
    if (token && !this.socket) {
      this.socket = io.connect(environment.backend + '/user', {
        path: '/socket.io-client',
        query: { token },
        multiplex: false,
      });

      // this.sessionSocket.on('error', err => Raven.captureMessage(err));
      this.socket.on('error', err => console.error(err));
      this.listeners = [];
    }
  }

  disconnect() {
    if (this.socket && this.socket.connected) {
      this.socket.disconnect();
      this.socket = undefined;
    }
  }

  /**
   * Register listeners for user events.
   * @param user
   */
  syncUpdates(user: CurrentUser) {
    const addListener = (event, callback) => {
      if (this.socket) {
        this.socket.on(event, callback);
        this.listeners.push(event);
      }
    };
    // Listen to all events

    addListener('user-notifications:read', update => {
      user.notifications = user.notifications.map(notif => {
        if (notif._id === update.notif_id) {
          notif.read = true;
        }
        return notif;
      });
    });

    addListener('user-notifications:seen', () => {
      user.notifications = user.notifications.map(notif => {
        notif.seen = true;
        return notif;
      });
    });

    addListener('user-notifications:create', update => {
      user.notifications = user.notifications || [];
      const updated = user.notifications.concat([update.notification]);
      user.notifications = updated;
    });
  }

  /**
   * Register listeners for user events (as component).
   * @param user
   */
  syncUpdatesComponent(component: NotificationCenterComponent) {
    const addListener = (event, callback) => {
      this.socket.on(event, callback);
      this.listeners.push(event);
    };
    // Listen to all events

    addListener('user-notifications:read', update => {
      component.user.notifications = component.user.notifications.map(notif => {
        if (notif._id === update.notif_id) {
          notif.read = true;
        }
        return notif;
      });
      component.update();
    });

    addListener('user-notifications:seen', () => {
      component.user.notifications = component.user.notifications.map(notif => {
        notif.seen = true;
        return notif;
      });
      component.update();
    });

    addListener('user-notifications:create', update => {
      component.user.notifications = component.user.notifications || [];
      const updated = component.user.notifications.concat([
        update.notification,
      ]);
      component.user.notifications = updated;
      component.update();
      component.receiveNotif(update.notification);
    });
  }

  /**
   * Removes listeners for updates on the socket
   */
  unsyncUpdates() {
    if (this.socket) {
      _.forEach(this.listeners, event => this.socket.removeListener(event));
    }
    this.listeners = [];
  }
}
